import React from 'react';

import Header from '../../Components/Dashboard/Header/Header';
import Group from '../../Components/Dashboard/Admin/Groups/Group';


export default function GroupsPage() {
  return (
    <>
      <Header/>
      <div className="body">
        <Group/>
      </div>
    </>
  );
}
